import {HttpEndpoint, TendermintClient} from "@cosmjs/tendermint-rpc";

import {ClientOptions} from "./baseclient";
import {Client} from "./client";
import {AssetQueryExtension} from "./modules/asset";
import {AuthzQueryExtension} from "./modules/authz";
// import {AuthQueryExtension} from "./modules/auth";
import {BankQueryExtension} from "./modules/bank";
import {DistributionQueryExtension} from "./modules/distribution";
import {DocumentQueryExtension} from "./modules/document";
import {ElectoralQueryExtension} from "./modules/electoral";
import {FeegrantQueryExtension} from "./modules/feegrant";
import {GentlemintQueryExtension} from "./modules/gentlemint";
import {GovQueryExtension} from "./modules/gov";
import {IdQueryExtension} from "./modules/id";
import {NftQueryExtension} from "./modules/nft";
import {SbtQueryExtension} from "./modules/sbt";
import {SlashingQueryExtension} from "./modules/slashing";
import {StakingQueryExtension} from "./modules/staking";
import {SwapQueryExtension} from "./modules/swap";
import {TokenQueryExtension} from "./modules/token";
// import {TxQueryExtension} from "./modules/tx";
import {WasmQueryExtension} from "./modules/wasm";

export interface ShareledgerClient
  // AuthQueryExtension,
  extends BankQueryExtension,
    DistributionQueryExtension,
    GovQueryExtension,
    FeegrantQueryExtension,
    SlashingQueryExtension,
    StakingQueryExtension,
    // TxQueryExtension,
    AssetQueryExtension,
    DocumentQueryExtension,
    ElectoralQueryExtension,
    GentlemintQueryExtension,
    IdQueryExtension,
    SwapQueryExtension,
    FeegrantQueryExtension,
    WasmQueryExtension,
    TokenQueryExtension,
    NftQueryExtension,
    SbtQueryExtension,
    AuthzQueryExtension {}

// @AuthQueryExtension
@BankQueryExtension
@DistributionQueryExtension
@GovQueryExtension
@FeegrantQueryExtension
@SlashingQueryExtension
@StakingQueryExtension
// @TxQueryExtension
@AssetQueryExtension
@DocumentQueryExtension
@ElectoralQueryExtension
@GentlemintQueryExtension
@IdQueryExtension
@SwapQueryExtension
@FeegrantQueryExtension
@WasmQueryExtension
@TokenQueryExtension
@NftQueryExtension
@SbtQueryExtension
@AuthzQueryExtension
export class ShareledgerClient extends Client {
  /**
   * Creates an instance by connecting to the given Tendermint RPC endpoint.
   *
   * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
   * To set the Tendermint client explicitly, use `create`.
   */
  public static async connect(endpoint: string | HttpEndpoint, options: ClientOptions = {}): Promise<ShareledgerClient> {
    const tmClient = await this.createTmClient(endpoint);
    return ShareledgerClient.create(tmClient, options);
  }

  /**
   * Creates an instance from a manually created Tendermint client.
   * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
   */
  public static async create(tmClient: TendermintClient, options: ClientOptions = {}): Promise<ShareledgerClient> {
    return new ShareledgerClient(tmClient, options);
  }
}
